const address = '391 Blue Mountain Rd. Santa Rosa Beach, FL 32459';

const checkInformation = {
  checkIn: 'May 28 at 3:00 pm',
  checkOut: 'May 31 at 11:00 am',
};

const descriptions = ['2 guest honeymoon.', 'AR sent.', 'Something else that might be important.'];

const propertyName = 'Sea-esta 10';

const photo =
  'https://images.pexels.com/photos/106399/pexels-photo-106399.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260';

const summary = 'Staying for 3 days with 2 guests';

export { address, checkInformation, descriptions, propertyName, photo, summary };
